import "vant/es/progress/style";
import _Progress from "vant/es/progress";
import _objectSpread from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/pk/vs.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-138f6d09"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "pk-loading-wrap"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  class: "loading-content rotate"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "loading-text"
  }, "正在匹配中...", -1);
});
var _hoisted_6 = {
  key: 1,
  class: "pk-match-wrap"
};
var _hoisted_7 = {
  class: "match-content"
};
var _hoisted_8 = {
  class: "match-left animate__animated animate__slideInLeft"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "match-name"
};
var _hoisted_11 = {
  class: "match-right animate__animated animate__slideInRight"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "match-name"
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "match-logo animate__animated animate__jackInTheBox",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "progress-tips"
  }, "正在准备答题战场...", -1);
});
import { onMounted, ref, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useCommonQuesListEffect } from '@/effects/quesListEffect';
export default {
  __name: 'pkLoading',
  setup: function setup(__props) {
    var showMatch = ref(false);

    //  1.2s后显示匹配成功
    setTimeout(function () {
      showMatch.value = true;
    }, 1800);
    var percentage = ref(0);

    // 随机1s到2.5s
    var randomTime = Math.floor(Math.random() * 1500) + 1000;
    // percentage在随机时间内，逐步增加到100
    setTimeout(function () {
      var timer = setInterval(function () {
        percentage.value += 1;
        if (percentage.value >= 100) {
          clearInterval(timer);
        }
      }, 10);
    }, randomTime);
    var router = useRouter();
    var route = useRoute();
    var store = useStore();
    watch(percentage, function () {
      if (percentage.value >= 100) {
        setTimeout(function () {
          // 记录答题开始时间
          store.commit('setStartTime', {
            time: new Date()
          });
          router.push({
            path: '/competition/question',
            query: _objectSpread(_objectSpread({}, route.query), {}, {
              type: 'pk'
            })
          });
        }, 500);
      }
    });

    // 获取随机用户信息,从public下的json下的user.json中获取
    var getUserInfo = function getUserInfo() {
      var users = require('/public/json/user.json');
      var randomIndex = Math.floor(Math.random() * users.length);
      var user = users[randomIndex];
      store.commit('setRobot', user);
    };
    var robot = computed(function () {
      var _store$getters;
      return (_store$getters = store.getters) === null || _store$getters === void 0 ? void 0 : _store$getters.getRobot;
    });
    var user = computed(function () {
      var _store$getters2;
      return (_store$getters2 = store.getters) === null || _store$getters2 === void 0 ? void 0 : _store$getters2.getUser;
    });

    // 提前获取题目数据
    var _useCommonQuesListEff = useCommonQuesListEffect(),
      getQuesData = _useCommonQuesListEff.getQuesData,
      loading = _useCommonQuesListEff.loading;
    onMounted(function () {
      getQuesData();
      getUserInfo();
    });
    return function (_ctx, _cache) {
      var _user$value, _user$value2, _robot$value, _robot$value2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!showMatch.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "avatar",
        src: (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.avatar,
        alt: ""
      }, null, 8, _hoisted_4)]), _hoisted_5])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
        class: "match-avatar",
        src: user.value.avatar,
        alt: ""
      }, null, 8, _hoisted_9), _createElementVNode("p", _hoisted_10, _toDisplayString((_user$value2 = user.value) === null || _user$value2 === void 0 ? void 0 : _user$value2.nickname), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        class: "match-avatar",
        src: (_robot$value = robot.value) === null || _robot$value === void 0 ? void 0 : _robot$value.avatar,
        alt: ""
      }, null, 8, _hoisted_12), _createElementVNode("p", _hoisted_13, _toDisplayString((_robot$value2 = robot.value) === null || _robot$value2 === void 0 ? void 0 : _robot$value2.nickname), 1)]), _hoisted_14]), _createVNode(_unref(_Progress), {
        class: "match-progress",
        percentage: percentage.value,
        "stroke-width": "18"
      }, null, 8, ["percentage"]), _hoisted_15]))]);
    };
  }
};